import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ApiService, ApiHelperService } from '../../../shared';
import { UserProfile } from '../models';
import { map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class UserService {

  userEndpointUrl: string;

  constructor(
    private api: ApiService,
    { userServiceUrl }: ApiHelperService) {
    this.userEndpointUrl = `${userServiceUrl}/api/user`;
  }

  getProfile(): Observable<UserProfile> {
    return this.api.get(`${this.userEndpointUrl}/profile`).pipe(
      map(response => response.data)
    );
  }

  updateProfile(profile: UserProfile): Observable<any> {
    return this.api.post(`${this.userEndpointUrl}/profile`, profile)
      .pipe(
        map(response => response.data)
      );
  }

  private handleError(response: HttpErrorResponse) {
    return throwError(response?.error?.errors);
  }
}
